module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4BAMAAABaqCYtAAAAAXNSR0IArs4c6QAAACFQTFRFAAAA////nJycl5eXnZ2dmZmZmZmZmZmZmZmZmZmZmZmZ/Px4FQAAAAp0Uk5TAAFfYGDe3+7v/gPyC5sAAABsSURBVDjLY2AYBRDA1LUKDJIYGDwgrKUKcEk2iMiqFQyMWVBmAVySCyqyioERxpowKkkHSQ5MyQC4JHMWuuRyA5onIkEowJfAEA7CksCQvDKawAZckh0qsoyBsQszgUXOBINiBgYzuiWwoQIA1hh43xsON+0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/qita@2x.png
// module id = hXvT
// module chunks = 1